import { CMS } from '~/scopes/cms/routes-names'

export const priceGuidesHubLinkDefinition = {
  name: CMS.EVENT,
  params: { pageName: 'price-guides' },
}
